export default __webpack_public_path__ + "static/media/linkedIn_logo.fd9e4298.svg";